export default [
    {
        path: '/chats',
        name: 'chats',
        
        component: () => import('../../pages/chats').then(m => m.default || m),
       
    }
]
